export const surveyEndPoint = `surveys`;
export const CustomVariablesEndPoint = `variables`;
